// extracted by mini-css-extract-plugin
export default {"root":"booking_category_select-modules___root___d4dd2e5e","boxDisabled":"booking_category_select-modules___boxDisabled___c2904534"};